exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-date {\n  display: none !important;\n}\n[dir=ltr] .vc-date-time {\n  margin-left: 0px !important;\n}\n[dir=rtl] .vc-date-time {\n  margin-right: 0px !important;\n}\n.vc-time-picker[data-v-ee473b46] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[dir] .vc-time-picker[data-v-ee473b46] {\n  padding: 0px !important;\n}\n.vc-time-icon[data-v-ee473b46] {\n  display: none !important;\n}", ""]);

// exports
